// Built-in preset bundles for <DateRangeDropdown>. Pure functions of `today`
// so callers can pass a frozen reference in tests for determinism.

import { addDays, formatIso, startOfMonth, today } from './dateUtils';
import { DateRangePresetSpec } from './DateRangeDropdown';

function startOfNextMonth(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth() + 1, 1);
}

function endOfMonth(d: Date): Date {
  return addDays(startOfNextMonth(d), -1);
}

function addWorkingDays(start: Date, n: number): Date {
  let d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let added = 0;
  while (added < n) {
    d = addDays(d, 1);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) added += 1;
  }
  return d;
}

/**
 * Backward-looking presets — sensible for "filter recent orders" surfaces
 * (Logistics → Orders).
 */
export function backwardPresets(now: Date = today()): DateRangePresetSpec[] {
  return [
    { label: 'Today', start: formatIso(now), end: formatIso(now) },
    { label: 'Last 7 days', start: formatIso(addDays(now, -6)), end: formatIso(now) },
    { label: 'This month', start: formatIso(startOfMonth(now)), end: formatIso(endOfMonth(now)) },
    { label: 'Last 30 days', start: formatIso(addDays(now, -29)), end: formatIso(now) },
  ];
}

/**
 * Forward-looking presets — sensible for "forecast next N days" surfaces
 * (Logistics → Forecast).
 */
export function forwardPresets(now: Date = today()): DateRangePresetSpec[] {
  return [
    { label: 'Next 7 days', start: formatIso(now), end: formatIso(addDays(now, 6)) },
    {
      label: 'Next 30 working days',
      start: formatIso(now),
      end: formatIso(addWorkingDays(now, 29)),
    },
    { label: 'This month', start: formatIso(startOfMonth(now)), end: formatIso(endOfMonth(now)) },
  ];
}
